import React, { useEffect, useState } from 'react';
import AdminLayout from '../../../components/layout/AdminLayout';
import { useNavigate, useParams } from 'react-router-dom';
import { ActivitySpeciesTypeDTO } from '../../../services/apiClient';
import { useActivitySpeciesTypeApi } from '../../../hooks/useActivitySpeciesTypeApi';
import ActivitySpeciesTypeForm from '../../../components/forms/ActivitySpeciesTypeForm';

const ActivitySpeciesTypeEdit: React.FC = () => {
  const { getById, edit, isLoading } = useActivitySpeciesTypeApi();
  const [entityData, setEntityData] = useState<ActivitySpeciesTypeDTO | null>(null);
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();

  const breadcrumbs = [
    { label: 'Admin', href: '#' },
    { label: 'Activity Species', href: '/admin/activityspeciestype' },
    { label: 'Edit', href: '#' },
  ];

  useEffect(() => {
    const fetchEntityData = async () => {
      try {
        const response = await getById(id!);
        setEntityData(response?.data || null);
      } catch (error) {
        console.error('Error fetching ActivitySpeciesType data:', error);
      }
    };

    fetchEntityData();
  }, [id]);

  const handleSubmit = async (data: any) => {
    try {
      await edit(id!, data);
      navigate('/admin/activityspeciestype');
    } catch (error) {
      console.error('Error updating ActivitySpeciesType:', error);
    }
  };

  return (
    <AdminLayout
      activeMenuItem="/admin/activityspeciestype"
      breadcrumbs={breadcrumbs}
      allowedRoles={['Admin']}
      requiredPermission="Settings.ActivitySpeciesType.Edit"
    >
      {entityData ? (
        <ActivitySpeciesTypeForm
          initialValues={entityData}
          onSubmit={handleSubmit}
          onCancel={() => navigate('/admin/activityspeciestype')}
        />
      ) : (
        <p>Loading...</p>
      )}
    </AdminLayout>
  );
};

export default ActivitySpeciesTypeEdit;
